import { render, staticRenderFns } from "./RSidebar2.vue?vue&type=template&id=4d364b83&"
import script from "./RSidebar2.vue?vue&type=script&lang=js&"
export * from "./RSidebar2.vue?vue&type=script&lang=js&"
import style0 from "./RSidebar2.vue?vue&type=style&index=0&id=4d364b83&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports